module.exports = __webpack_public_path__ + "img/close-image-without-back.d1e929c2.png";